import {engineContext} from './context.js';

(function(global){'use strict';
const VERSION='0.1.0-alpha';

function norm(x){
  x=x||{};
  return Object.freeze({
    taskId:x.taskId||null,
    symbol:x.symbol||null,
    taskType:x.taskType||'UNKNOWN',
    evidenceFingerprint:x.evidenceFingerprint||null,
    completedFingerprint:x.completedFingerprint||null,
    completionState:['OPEN','COMPLETED','PARTIAL','BLOCKED'].includes(x.completionState)?x.completionState:'OPEN',
    estimatedMinutes:Number.isFinite(x.estimatedMinutes)?Math.max(1,Math.round(x.estimatedMinutes)):15,
    actualMinutes:Number.isFinite(x.actualMinutes)?Math.max(0,Math.round(x.actualMinutes)):null,
    reusable:x.reusable!==false
  });
}

function shouldDo(x){
  const n=norm(x);
  if(n.completionState==='BLOCKED') return Object.freeze({doTask:false,reason:'BLOCKED'});
  if(n.completionState==='COMPLETED' && n.evidenceFingerprint && n.evidenceFingerprint===n.completedFingerprint)
    return Object.freeze({doTask:false,reason:'UNCHANGED_EVIDENCE'});
  if(n.completionState==='COMPLETED' && n.evidenceFingerprint!==n.completedFingerprint)
    return Object.freeze({doTask:true,reason:'EVIDENCE_CHANGED'});
  if(n.completionState==='PARTIAL') return Object.freeze({doTask:true,reason:'PARTIAL'});
  return Object.freeze({doTask:true,reason:'OPEN'});
}

function dedupe(items){
  const rows=(Array.isArray(items)?items:[]).map(norm),m=new Map();
  for(const r of rows){
    const key=`${r.symbol||'UNKNOWN'}|${r.taskType}|${r.evidenceFingerprint||'NO_FP'}`;
    if(!m.has(key)) m.set(key,r);
    else {
      const old=m.get(key);
      if((r.completionState==='COMPLETED' && old.completionState!=='COMPLETED') ||
         ((r.actualMinutes||0)>(old.actualMinutes||0))) m.set(key,r);
    }
  }
  return Object.freeze([...m.values()]);
}

function savings(items){
  const rows=dedupe(items);
  let avoided=0,required=0,avoidedTasks=0,requiredTasks=0;
  for(const r of rows){
    const d=shouldDo(r);
    if(d.doTask){required+=r.estimatedMinutes;requiredTasks++;}
    else if(d.reason==='UNCHANGED_EVIDENCE'){avoided+=r.estimatedMinutes;avoidedTasks++;}
  }
  return Object.freeze({
    avoidedMinutes:avoided,
    requiredMinutes:required,
    avoidedTasks,
    requiredTasks,
    totalConsidered:rows.length,
    tradeSignal:false,
    universalScore:null
  });
}

function selfTest(){
  const t=[],ok=(n,p)=>t.push({name:n,pass:!!p});
  const done={taskId:'1',symbol:'AAA',taskType:'VERIFY_DEMAND',evidenceFingerprint:'e1',completedFingerprint:'e1',completionState:'COMPLETED',estimatedMinutes:20};
  const changed={...done,taskId:'2',evidenceFingerprint:'e2'};
  const open={taskId:'3',symbol:'BBB',taskType:'CHECK_MARGIN',completionState:'OPEN',estimatedMinutes:15};

  ok('completed task with unchanged evidence is skipped',shouldDo(done).doTask===false);
  ok('skip reason identifies unchanged evidence',shouldDo(done).reason==='UNCHANGED_EVIDENCE');
  ok('changed evidence reopens completed task',shouldDo(changed).doTask===true);
  ok('changed evidence reason is explicit',shouldDo(changed).reason==='EVIDENCE_CHANGED');
  ok('open task remains actionable',shouldDo(open).doTask===true);
  ok('partial task remains actionable',shouldDo({...open,completionState:'PARTIAL'}).doTask===true);
  ok('blocked task is not scheduled',shouldDo({...open,completionState:'BLOCKED'}).doTask===false);

  const dup=[open,{...open,taskId:'4'}];
  ok('duplicate same task/evidence compressed',dedupe(dup).length===1);

  const s=savings([done,open]);
  ok('avoided research minutes counted',s.avoidedMinutes===20);
  ok('required research minutes counted',s.requiredMinutes===15);
  ok('avoided task count reported',s.avoidedTasks===1);
  ok('required task count reported',s.requiredTasks===1);
  ok('no trade signal',s.tradeSignal===false);
  ok('no universal score',s.universalScore===null);

  return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}

const API={VERSION,norm,shouldDo,dedupe,savings,selfTest};
try{API.selfTestResult=selfTest()}catch(e){API.bootstrapError=String(e&&e.stack||e)}
global.ZooInvestResearchEfficiencyEngine=Object.freeze(API);
})(engineContext);